import { IModel } from 'app/model/base/annotation';
import { Named } from '../base/named';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowDataType, IDataFlowDataType } from '../dataflow/dataflow-datatype';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowTypesUtils } from '../dataflow/dataflow-type-utilities';
import { DataFlowUtils } from 'app/authoring/component/transformations/dataFlow-utils';

export interface IBasedOnEntity {
    name?: string;
    dataFlowColumnType?: IDataFlowDataType;
}

export interface IBasedOnEntityRef {
    name: string;
    originalName: string;
    entity: IBasedOnEntity;
    owningStreamName: string;
    siblingEntities: IBasedOnEntity[];
    rootEntity: IBasedOnEntity;
}

@Metamodel.model({
    name: 'dataflowcolumn',
    display: [stringResources.Column, stringResources.ModelName_Columns],
    referable: true,
    globalScope: true
})
export class DataFlowColumn extends Named implements IBasedOnEntity {
    public static readonly MODEL: IModel;

    public dataFlowColumnType?: IDataFlowDataType;
    public nameDependsOnBasedColumn?: boolean;
    public isTransient?: boolean;

    @Metamodel.attribute({
        transient: true
    })
    public basedOnArguments: IBasedOnEntity[] = [];

    @Metamodel.attribute({
        transient: true
    })
    public columnPattern?: DataFlowColumn;

    @Metamodel.attribute({
    })
    public get columnTypeFormat(): string {
        return this.dataFlowColumnType && this.dataFlowColumnType.format || '';
    }

    public set columnTypeFormat(format: string) {
        if (this.dataFlowColumnType) {
            this.dataFlowColumnType.format = format;
        }
    }

    public get columnType(): string {
        return this.dataFlowColumnType ? this.dataFlowColumnType.typeString : undefined;
    }

    // Should only be used from drop down where datatype is being changed, like in projection or schema tabs.
    public set columnType(columnType: string) {
        this.dataFlowColumnType = DataFlowTypesUtils.createType(columnType);
    }

    public get ownerTransformation(): Transformation {
        return (super.getOwner().named as Transformation);
    }

    public get serializableColumnName(): string {
        return DataFlowUtils.needToEscape(this.name) ? `{${this.name}}` : this.name;
    }

    /*
        Represents the physical name and its description
    */
    constructor(name?: string, description?: string) {
        super(name, description);
    }
    public get columnTypeName(): DataFlowDataType {
        return this.dataFlowColumnType ? this.dataFlowColumnType.typeString : undefined;
    }

    // Should only be used from drop down where datatype is being changed, like in projection or schema tabs.
    public set columnTypeName(columnType: DataFlowDataType) {
        this.dataFlowColumnType = DataFlowTypesUtils.createType(columnType);
    }
}
